﻿export class Loader {
    private loader: HTMLDivElement;
    private overlay: HTMLDivElement;

    constructor() {
        // Create the overlay
        this.overlay = document.createElement("div");
        this.overlay.id = "loader-overlay";
        this.overlay.style.position = "fixed";
        this.overlay.style.top = "0";
        this.overlay.style.left = "0";
        this.overlay.style.width = "100%";
        this.overlay.style.height = "100%";
        this.overlay.style.backgroundColor = "rgba(0, 0, 0, 0.5)"; // Semi-transparent background
        this.overlay.style.display = "none"; // Initially hidden

        // Create the loader
        this.loader = document.createElement("div");
        this.loader.id = "loader";
        this.loader.style.position = "fixed";
        this.loader.style.top = "50%";
        this.loader.style.left = "50%";
        this.loader.style.transform = "translate(-50%, -50%)";
        this.loader.style.border = "16px solid #f3f3f3";
        this.loader.style.borderTop = "16px solid #3498db";
        this.loader.style.borderRadius = "50%";
        this.loader.style.width = "120px";
        this.loader.style.height = "120px";
        this.loader.style.animation = "spin 2s linear infinite";

        // Add CSS for the loader animation
        const style = document.createElement("style");
        style.type = "text/css";
        style.innerHTML = `
        @keyframes spin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
        }
        `;
        document.head.appendChild(style);

        // Append the loader to the overlay
        this.overlay.appendChild(this.loader);
        document.body.appendChild(this.overlay);
    }

    show() {
        this.overlay.style.display = "block";
    }

    hide() {
        this.overlay.style.display = "none";
    }
}

